// src/hooks/useSummary.ts

import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
} from "firebase/firestore";

import { db } from "../firebase";
import { useLoading } from "./useLoading";

export interface SummaryData {
  id: string;
  title?: string;
  description?: string;
  updatedAt?: any;
  information?: string;
  quartetSemiFinalVenue?: string;
  quartetFinalVenue?: string;
  chorusFinalVenue?: string;
  evaluationOnlyVenue?: string;
  quartetSemiFinalAt?: any;
  quartetFinalAt?: any;
  chorusFinalAt?: any;
  evaluationOnlyAt?: any;
  judgePanelADM?: string;
  judgePanelMUS?: string;
  judgePanelPER?: string;
  judgePanelSNG?: string;
}

export const useSummary = () => {
  const [summaries, setSummaries] = useState<
    SummaryData[]
  >([]);

  const { isLoading, setIsLoading } =
    useLoading();

  const fetchSummary = async () => {
    try {
      setIsLoading(true);

      const querySnapshot = await getDocs(
        collection(db, "summary"),
      );

      const summaryList = querySnapshot.docs.map(
        (doc) => ({
          id: doc.id,
          ...(doc.data() as Omit<
            SummaryData,
            "id"
          >),
        }),
      );

      // 年順に並び替え
      summaryList.sort(
        (a, b) => Number(b.id) - Number(a.id),
      );

      setSummaries(summaryList);
    } catch (error) {
      console.error(
        "summary取得エラー:",
        error,
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return {
    loading: isLoading,
    summaries,
    fetchSummary,
  };
};